import {VisitAPIDataSource} from '../api/VisitAPIDataSource';
import {mapVisitDTOToModel} from '../mappers/visit.mapper';
import {Visit} from '../models/visit.model';

export class GetVisitDetailsUseCase {
  async execute (visitId: string | number): Promise<Visit> {
    try {
      const dto = await VisitAPIDataSource.getVisitDetails(visitId);
      return mapVisitDTOToModel(dto);
    } catch (error) {
      throw error;
    }
  }
}
